<template>
  <div class="side-buttons">
    <v-btn
      v-for="(btn, i) in buttons"
      :key="i"
      color="primary"
      :to="btn.to"
      @click="btn.click"
    >
      {{ btn.text }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    buttons: {
      type: Array,
      required: true,
      validator: value => value.reduce(
        (acc, btn) => acc && (btn.click || btn.to) && btn.text,
        true
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.side-buttons {
  position: fixed;
  bottom: 30px;
  right: 80px;
}
</style>
